import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=64910c78&scoped=true&lang=html&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64910c78",
  null
  
)

export default component.exports